import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo from './../assets/logofinal.svg'
import LoginBG from './../assets/hintergrund.jpg'


const Changelog = () => {
  return(
    <Grid container component="main" sx={{ height: '100vh' }}>
      <Grid item xs={12} sm={12} md={7} sx={{
          backgroundImage: `url(${LoginBG})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: (t) =>
            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
        <Grid item xs={12} sm={12} md={5} component={Paper} elevation={6} px={6}>
            <Box sx={{ textAlign: 'center', mb: 5}}>
              <img style={{marginBottom: '20px'}} src={logo} />
              <h2>Änderungen</h2>
            </Box>
            <Box sx={{ pt: 5, display: 'flex', flexDirection: 'column', maxHeight: "80vh", overflowY: "scroll" }}>
                <Box sx={{ textAlign: 'left', mb: 5}}>
                    <Typography variant="h5">Roadmap</Typography>
                    <ul> 
                      <li>keine anstehenden Änderungen</li>
                    </ul>
                </Box>
            </Box>
        </Grid>
      </Grid>
  );
};

export default Changelog;